"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tfs_css_variables_1 = __importDefault(require("tfs.css-variables"));
var brandStyles = {
    easeOutBack: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    paceDefault: '200ms',
    borderRadiusDefault: '8px',
};
exports.default = {
    input: {
        width: '100%',
        padding: '0.55rem 1rem',
        fontSize: '1rem',
        lineHeight: 1,
        border: "1px solid " + tfs_css_variables_1.default.colorWhiteBorder,
        borderRadius: brandStyles.borderRadiusDefault,
        color: tfs_css_variables_1.default.colorGrayA,
        backgroundColor: tfs_css_variables_1.default.colorWhite,
        transition: tfs_css_variables_1.default.paceFast + " " + tfs_css_variables_1.default.easeIn + " border",
        '&::placeholder': {
            color: tfs_css_variables_1.default.colorGrayD,
        },
        '&:hover, &:focus': {
            outline: 'none',
            border: "1px solid " + tfs_css_variables_1.default.colorBlue,
        },
        '&[type="radio"]': {
            position: 'absolute',
            clip: 'rect(0,0,0,0)',
            width: 'auto',
        },
        '&[type="radio"] + label': {
            position: 'relative',
            padding: '0 0 0 2rem',
        },
        '&[type="radio"] + label:before': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '0',
            width: '1.5rem',
            height: '1.5rem',
            transform: 'translateY(-50%)',
            border: "1px solid " + tfs_css_variables_1.default.colorGrayC,
            borderRadius: '50%',
            backgroundColor: 'white',
        },
        '&[type="radio"] + label:after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '0',
            width: '.75rem',
            height: '.75rem',
            transform: 'translate(.45rem, -50%) scale(0)',
            backgroundColor: tfs_css_variables_1.default.colorBlue,
            borderRadius: '50%',
            transition: brandStyles.paceDefault + " " + brandStyles.easeOutBack + " transform",
        },
        '&[type="radio"]:checked + label:after': {
            transform: 'translate(.45rem, -50%) scale(1)',
        },
        '&[type="radio"]:focus + label:before': {
            boxShadow: '0px 0px 0px 1px rgba(42, 16, 157, 0.5)',
        },
        '&[type="checkbox"]': {
            width: 'auto',
        },
        '&:-moz-read-only': {
            border: 'none',
            background: 'transparent',
        },
        '&:read-only': {
            border: 'none',
            background: 'transparent',
            outline: 'none',
        },
        '&:disabled': {
            border: 'none',
            background: tfs_css_variables_1.default.colorGrayE,
            outline: 'none',
        },
        '&[data-error="true"]': {
            borderColor: tfs_css_variables_1.default.colorError,
            outline: 'none',
        },
    },
};
//# sourceMappingURL=FormInput.styles.js.map